export const initialState = {
  status: "All",
  search: "",
};
